import { Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  isActive: false,
  onClick: null
};
const propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};

const Folder = ({ isActive, onClick, id, title, children }) => (
  <div className={cx('folder')}>
    <div className={cx('title')} onClick={() => onClick(id)}>
      <Icon type={isActive ? 'folder-open' : 'folder'} className="mr-sm" />
      {title}
    </div>
    <div
      className={cx('reportsContainer', {
        visible: isActive
      })}
    >
      {children}
    </div>
  </div>
);

Folder.defaultProps = defaultProps;
Folder.propTypes = propTypes;
export default Folder;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/Folder.jsx